import { Box, Tooltip, Chip } from "@mui/joy";
import { Edit as EditIcon } from "lucide-react";
import type { ICellRendererParams } from "ag-grid-community";

import { IconButton } from "../../../../../../shared";

interface InfoProps extends ICellRendererParams {
    onEdit?: (product: any) => void;
}

/**
 * Info cell renderer - shows edit button
 */
export function Info(props: InfoProps) {
    const { data, onEdit } = props;

    const handleClick = () => {
        if (onEdit && data) {
            onEdit(data);
        }
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title="Edit product" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "--IconButton-size": "32px",
                    }}
                >
                    <EditIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

/**
 * Status cell renderer
 */
export function StatusCellRenderer(params: ICellRendererParams) {
    const isActive = params.value === 1 || params.value === true;

    return (
        <Chip
            variant="soft"
            color={isActive ? "success" : "neutral"}
            size="md"
            sx={{
                fontWeight: 500,
                borderRadius: "4px",
                border: "1px solid",
                borderColor: "divider",
            }}
        >
            {isActive ? "Active" : "Inactive"}
        </Chip>
    );
}
